import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

interface IProps {
    isComplete?: boolean,
    isUnactive?: boolean,
}

const getFontColor = (p: IProps) => {
    if (p.isUnactive) {
        return COLORS.TextDisabled;
    }

    if (p.isComplete) {
        return COLORS.TextWhite;
    }

    return COLORS.TextPrimary;
};

export const StageTitleWrapper = styled.div`
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
`;

export const StageNumberWrap = styled.div<IProps>`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 2px solid ${p => p.isUnactive ? COLORS.GRAY_LIGHT : COLORS.Control};
    background-color: ${p => p.isComplete ? COLORS.Control : 'transparent'};
`;

export const StageNumber = styled.div<IProps>`
    ${FONTS.H5};
    line-height: 1;
    color: ${p => getFontColor(p)};
`;

export const StageTitle = styled.div<IProps>`
    ${FONTS.H3};
    color: ${p => p.isUnactive ? COLORS.TextDisabled : COLORS.TextPrimary};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H4};
    }
`;

export const StageSubTitle = styled.span`
    white-space: nowrap;
`;
